module.exports = __webpack_public_path__ + "img/cake-7.9eaf17b7.svg";